import React, { useMemo } from 'react';
import { useFormContext, Controller } from 'react-hook-form';

import {
  ControlledDateField,
  ControlledTagAutocomplete,
  QualificationsField,
} from '@vyce/core/src/components/controlled-inputs';
import { AppTextField } from '@vyce/core/src/components/inputs';
import { Tag } from '@vyce/core/src/types';

import { Modes, rules } from '../config';

export const NotListedAcademicQualificationForm = ({
  tags,
  isAdmin,
  setSubstring,
  editMode,
}: {
  tags: Tag[];
  isAdmin: boolean;
  setSubstring: (arg0: string) => void;
  editMode: keyof typeof Modes | null;
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const titleRules = useMemo(
    () =>
      editMode === Modes.create
        ? {
            required: 'This field is required',
            validate: (value: Tag | string | null) =>
              (!!value && typeof value === 'object' && !!value.uuid) ||
              'Please select a qualification from the list',
          }
        : rules,
    [editMode]
  );

  return (
    <>
      <QualificationsField name="title" label="Academic Title" rules={titleRules} margin="none" />
      <ControlledTagAutocomplete
        name="extra_text"
        margin="none"
        items={tags}
        label="Institute Name"
        rules={rules}
        setSubstring={setSubstring}
        manualMode={isAdmin}
      />
      <Controller
        control={control}
        name="reference_number"
        render={({ field }) => (
          <AppTextField
            {...field}
            label="Reference number"
            margin="none"
            fullWidth
            error={!!errors.reference_number?.message}
            helperText={(errors.reference_number?.message as string) || ''}
          />
        )}
      />
      <ControlledDateField name="date" label="Date Awarded" disableFuture />
    </>
  );
};
